// tslint:disable
/**
 * Import-export manager api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { Import } from '../models';
import { ImportList } from '../models';
/**
 * ImportApi - axios parameter creator
 * @export
 */
export const ImportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get import by id.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImport(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getImport.');
            }
            const localVarPath = `/import/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get list of Import.
         * @param {Array<string>} [ids] 
         * @param {string} [companyId] 
         * @param {'course_v1_json' | 'user_csv' | 'student_csv' | 'contractor_csv'} [type] 
         * @param {Date} [startedAtMin] 
         * @param {Date} [startedAtMax] 
         * @param {Date} [finishedAtMin] 
         * @param {Date} [finishedAtMax] 
         * @param {boolean} [success] 
         * @param {'Not started' | 'Started' | 'Successfully' | 'Failed'} [status] 
         * @param {Date} [createdAtMin] 
         * @param {Date} [createdAtMax] 
         * @param {Date} [updatedAtMin] 
         * @param {Date} [updatedAtMax] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {'startedAt' | 'finishedAt' | 'createdAt' | 'updatedAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listImport(ids?: Array<string>, companyId?: string, type?: 'course_v1_json' | 'user_csv' | 'student_csv' | 'contractor_csv', startedAtMin?: Date, startedAtMax?: Date, finishedAtMin?: Date, finishedAtMax?: Date, success?: boolean, status?: 'Not started' | 'Started' | 'Successfully' | 'Failed', createdAtMin?: Date, createdAtMax?: Date, updatedAtMin?: Date, updatedAtMax?: Date, offset?: number, limit?: number, sort?: 'startedAt' | 'finishedAt' | 'createdAt' | 'updatedAt', order?: 'ASC' | 'DESC', options: any = {}): RequestArgs {
            const localVarPath = `/import`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (ids) {
                localVarQueryParameter['ids'] = ids.join(COLLECTION_FORMATS.csv);
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (startedAtMin !== undefined) {
                localVarQueryParameter['startedAtMin'] = (startedAtMin as any).toISOString();
            }

            if (startedAtMax !== undefined) {
                localVarQueryParameter['startedAtMax'] = (startedAtMax as any).toISOString();
            }

            if (finishedAtMin !== undefined) {
                localVarQueryParameter['finishedAtMin'] = (finishedAtMin as any).toISOString();
            }

            if (finishedAtMax !== undefined) {
                localVarQueryParameter['finishedAtMax'] = (finishedAtMax as any).toISOString();
            }

            if (success !== undefined) {
                localVarQueryParameter['success'] = success;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (createdAtMin !== undefined) {
                localVarQueryParameter['createdAtMin'] = (createdAtMin as any).toISOString();
            }

            if (createdAtMax !== undefined) {
                localVarQueryParameter['createdAtMax'] = (createdAtMax as any).toISOString();
            }

            if (updatedAtMin !== undefined) {
                localVarQueryParameter['updatedAtMin'] = (updatedAtMin as any).toISOString();
            }

            if (updatedAtMax !== undefined) {
                localVarQueryParameter['updatedAtMax'] = (updatedAtMax as any).toISOString();
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ImportApi - functional programming interface
 * @export
 */
export const ImportApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Get import by id.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImport(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Import> {
            const localVarAxiosArgs = ImportApiAxiosParamCreator(configuration).getImport(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get list of Import.
         * @param {Array<string>} [ids] 
         * @param {string} [companyId] 
         * @param {'course_v1_json' | 'user_csv' | 'student_csv' | 'contractor_csv'} [type] 
         * @param {Date} [startedAtMin] 
         * @param {Date} [startedAtMax] 
         * @param {Date} [finishedAtMin] 
         * @param {Date} [finishedAtMax] 
         * @param {boolean} [success] 
         * @param {'Not started' | 'Started' | 'Successfully' | 'Failed'} [status] 
         * @param {Date} [createdAtMin] 
         * @param {Date} [createdAtMax] 
         * @param {Date} [updatedAtMin] 
         * @param {Date} [updatedAtMax] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {'startedAt' | 'finishedAt' | 'createdAt' | 'updatedAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listImport(ids?: Array<string>, companyId?: string, type?: 'course_v1_json' | 'user_csv' | 'student_csv' | 'contractor_csv', startedAtMin?: Date, startedAtMax?: Date, finishedAtMin?: Date, finishedAtMax?: Date, success?: boolean, status?: 'Not started' | 'Started' | 'Successfully' | 'Failed', createdAtMin?: Date, createdAtMax?: Date, updatedAtMin?: Date, updatedAtMax?: Date, offset?: number, limit?: number, sort?: 'startedAt' | 'finishedAt' | 'createdAt' | 'updatedAt', order?: 'ASC' | 'DESC', options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportList> {
            const localVarAxiosArgs = ImportApiAxiosParamCreator(configuration).listImport(ids, companyId, type, startedAtMin, startedAtMax, finishedAtMin, finishedAtMax, success, status, createdAtMin, createdAtMax, updatedAtMin, updatedAtMax, offset, limit, sort, order, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ImportApi - factory interface
 * @export
 */
export const ImportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Get import by id.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImport(id: string, options?: any) {
            return ImportApiFp(configuration).getImport(id, options)(axios, basePath);
        },
        /**
         * Get list of Import.
         * @param {Array<string>} [ids] 
         * @param {string} [companyId] 
         * @param {'course_v1_json' | 'user_csv' | 'student_csv' | 'contractor_csv'} [type] 
         * @param {Date} [startedAtMin] 
         * @param {Date} [startedAtMax] 
         * @param {Date} [finishedAtMin] 
         * @param {Date} [finishedAtMax] 
         * @param {boolean} [success] 
         * @param {'Not started' | 'Started' | 'Successfully' | 'Failed'} [status] 
         * @param {Date} [createdAtMin] 
         * @param {Date} [createdAtMax] 
         * @param {Date} [updatedAtMin] 
         * @param {Date} [updatedAtMax] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {'startedAt' | 'finishedAt' | 'createdAt' | 'updatedAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listImport(ids?: Array<string>, companyId?: string, type?: 'course_v1_json' | 'user_csv' | 'student_csv' | 'contractor_csv', startedAtMin?: Date, startedAtMax?: Date, finishedAtMin?: Date, finishedAtMax?: Date, success?: boolean, status?: 'Not started' | 'Started' | 'Successfully' | 'Failed', createdAtMin?: Date, createdAtMax?: Date, updatedAtMin?: Date, updatedAtMax?: Date, offset?: number, limit?: number, sort?: 'startedAt' | 'finishedAt' | 'createdAt' | 'updatedAt', order?: 'ASC' | 'DESC', options?: any) {
            return ImportApiFp(configuration).listImport(ids, companyId, type, startedAtMin, startedAtMax, finishedAtMin, finishedAtMax, success, status, createdAtMin, createdAtMax, updatedAtMin, updatedAtMax, offset, limit, sort, order, options)(axios, basePath);
        },
    };
};

/**
 * ImportApi - object-oriented interface
 * @export
 * @class ImportApi
 * @extends {BaseAPI}
 */
export class ImportApi extends BaseAPI {
    /**
     * Get import by id.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApi
     */
    public getImport(id: string, options?: any) {
        return ImportApiFp(this.configuration).getImport(id, options)(this.axios, this.basePath);
    }

    /**
     * Get list of Import.
     * @param {Array<string>} [ids] 
     * @param {string} [companyId] 
     * @param {'course_v1_json' | 'user_csv' | 'student_csv' | 'contractor_csv'} [type] 
     * @param {Date} [startedAtMin] 
     * @param {Date} [startedAtMax] 
     * @param {Date} [finishedAtMin] 
     * @param {Date} [finishedAtMax] 
     * @param {boolean} [success] 
     * @param {'Not started' | 'Started' | 'Successfully' | 'Failed'} [status] 
     * @param {Date} [createdAtMin] 
     * @param {Date} [createdAtMax] 
     * @param {Date} [updatedAtMin] 
     * @param {Date} [updatedAtMax] 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {'startedAt' | 'finishedAt' | 'createdAt' | 'updatedAt'} [sort] 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApi
     */
    public listImport(ids?: Array<string>, companyId?: string, type?: 'course_v1_json' | 'user_csv' | 'student_csv' | 'contractor_csv', startedAtMin?: Date, startedAtMax?: Date, finishedAtMin?: Date, finishedAtMax?: Date, success?: boolean, status?: 'Not started' | 'Started' | 'Successfully' | 'Failed', createdAtMin?: Date, createdAtMax?: Date, updatedAtMin?: Date, updatedAtMax?: Date, offset?: number, limit?: number, sort?: 'startedAt' | 'finishedAt' | 'createdAt' | 'updatedAt', order?: 'ASC' | 'DESC', options?: any) {
        return ImportApiFp(this.configuration).listImport(ids, companyId, type, startedAtMin, startedAtMax, finishedAtMin, finishedAtMax, success, status, createdAtMin, createdAtMax, updatedAtMin, updatedAtMax, offset, limit, sort, order, options)(this.axios, this.basePath);
    }

}
